// extracted by css-extract-rspack-plugin
export default {"resultLink":"SearchResultLink-module__resultLink___bsRBY","resultLinkWrapper":"SearchResultLink-module__resultLinkWrapper___WJ6ff"};